// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"551":"3d7a68f3","842":"6bc07642"}[chunkId] + ".chunk.js";
};